import React, { useRef, useEffect } from "react";
import ACLStore from "lib/aclStore";
import _ from "lodash";

function useSetupConfigurationContext({
  configurationKey,
  configurations,
  configurationKeys = [configurationKey],
  configurationLists = [configurations],
}) {
  const previousContextIdsRef = useRef(new Array(configurationKeys.length));

  const unSubscribeCallbackRef = useRef(new Array(configurationKeys.length));

  _.forEach(configurationKeys, (configurationKey, index) => {
    if (configurationKey !== "NOT_DEFINED") {
      ACLStore.updateConfig(configurationKey, configurationLists[index]);
    }
  });

  _.forEach(configurationKeys, (configurationKey, index) => {
    if (
      configurationKey !== "NOT_DEFINED" &&
      previousContextIdsRef.current[index] !== configurationKey
    ) {
      if (unSubscribeCallbackRef.current[index]) {
        unSubscribeCallbackRef.current[index]();
      }

      previousContextIdsRef.current[index] = configurationKey;
      unSubscribeCallbackRef.current[index] = ACLStore.subscribeToContext(
        configurationKey
      );
    }
  });

  useEffect(() => {
    return () => {
      if (unSubscribeCallbackRef.current) {
        _.forEach(unSubscribeCallbackRef.current, unSubscribeCallback => {
          unSubscribeCallback?.();
        });
      }
    };
  }, []);
}

export default useSetupConfigurationContext;
